import { render, staticRenderFns } from "./modalEditTerm.vue?vue&type=template&id=ed73a22c&"
import script from "./modalEditTerm.vue?vue&type=script&lang=js&"
export * from "./modalEditTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports